import { Fragment, type FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Weekday } from '@dhl/components'

import { Skeleton, Box, Grid } from '@dhl-ui/components'
import { type ServicepointOpeningsTime } from './model.js'

type Props = {
  openingTimes: ServicepointOpeningsTime[]
}

const Time: FC<{ weekDay: number; labelHours: string; labelClosed: string } & Props> = ({
  weekDay,
  openingTimes,
  labelHours,
  labelClosed,
}) => {
  const result = openingTimes.filter((openingTime) => openingTime.weekDay === weekDay)

  if (!result.length) {
    return labelClosed
  }

  return (
    <Box mb={0.5}>
      {result.map(({ timeFrom, timeTo }) => (
        <Fragment key={timeFrom.unix()}>
          {timeFrom.format('HH:mm')} - {timeTo.format('HH:mm')} {labelHours}
        </Fragment>
      ))}
    </Box>
  )
}

export const ServicepointOpeningTimes: FC<Props> = ({ openingTimes }) => {
  const { t } = useTranslation()

  return (
    <Grid container>
      {Array.from({ length: 7 }, (_, i) => i + 1).map((weekDay) => (
        <Fragment key={weekDay}>
          <Grid size={4}>
            <Weekday weekDay={weekDay} />
          </Grid>
          <Grid size={8}>
            <Time
              weekDay={weekDay}
              openingTimes={openingTimes}
              labelHours={t('servicepoint.servicePointOpeneningTimes.hoursText')}
              labelClosed={t('servicepoint.servicePointOpeneningTimes.closedText')}
            />
          </Grid>
        </Fragment>
      ))}
    </Grid>
  )
}

export const ServicepointOpeningTimesSkeleton: FC = () => (
  <Grid container>
    {Array.from({ length: 7 }, (_, i) => i).map((index) => (
      <Fragment key={index}>
        <Grid size={4}>
          <Skeleton variant="text" width="60%" height={24} />
        </Grid>
        <Grid size={8}>
          <Skeleton variant="text" width="70%" height={24} />
        </Grid>
      </Fragment>
    ))}
  </Grid>
)
